import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AccidentAssignmentsScreen from 'AccidentManagement/AccidentAssignments/AccidentAssignmentsScreen';
import AccidentAssignmentsView from "AccidentManagement/AccidentAssignments/AddEditView/AccidentAssignmentsView";
const AccidentManagementRoute = (props) => {
    // Check feature flag FIRST, before rendering any routes
    if (props.isAccidentAssignmentFeatureEnabled === undefined) {
        return null;
    }
    if (!props.isAccidentAssignmentFeatureEnabled) {
        return React.createElement(Navigate, { to: "/", replace: true });
    }
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: "AccidentAssignments", element: React.createElement(AccidentAssignmentsScreen, { vendorId: props.vendorId }) }),
        React.createElement(Route, { path: "AccidentAssignments/:id", element: React.createElement(AccidentAssignmentsView, null) })));
};
export default AccidentManagementRoute;
